import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, Users, Star, MapPin } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-16 md:pt-24 pb-10 md:pb-16 px-4 md:px-8 max-w-4xl mx-auto" data-id="element-142">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="text-center flex flex-col items-center" data-id="element-143">
        <div className="inline-block px-4 py-1.5 bg-terracotta/10 text-terracotta rounded-full font-sans font-medium text-xs md:text-sm mb-4 md:mb-6" data-id="element-144">
          De Pareja a Familia
        </div>

        {/* Promesa de la landing */}
        <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl font-bold text-brown leading-tight mb-6 md:mb-8 max-w-3xl" data-id="element-145">
          Todo tu Primer Año de Familia, Resuelto en Equipo
        </h1>

        {/* Mockup principal — 70% del tamaño */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="w-[70%] mb-6 md:mb-8" data-id="element-146">
          <img src="https://cdn.magicpatterns.com/uploads/uYS7mw7xZVXUtCsP6MGH9E/ChatGPT_Image_17_jun_2026,_01_50_58_p.m..png" alt="Pareja leyendo juntos la guía De Pareja a Familia, con los tomos del sistema sobre la mesa" loading="eager" fetchPriority="high" decoding="async" className="w-full h-auto rounded-2xl shadow-xl border border-brown/10" data-id="element-147" />
        </motion.div>

        {/* Subtitulo del modulo inicial */}
        <p className="font-sans text-lg md:text-2xl text-terracotta font-medium mb-3 md:mb-4" data-id="element-148">
          Los 9 Meses Más Importantes, En Equipo
        </p>

        <p className="font-sans text-base md:text-lg text-brown/80 mb-6 md:mb-8 leading-relaxed max-w-2xl" data-id="element-149">
          La guía que transforma el embarazo de "cada uno por su lado" a un
          equipo conectado — semana a semana, con rituales concretos, no con
          buena suerte.
        </p>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-6 md:mb-8" data-id="element-150">
          {['PDF Digital', 'Acceso Inmediato', 'Para parejas que están esperando un bebé'].map((pill, i) => <span key={i} className="px-3 py-1 bg-offwhite border border-brown/10 rounded-full text-xs md:text-sm font-sans text-brown/70" data-id="element-151">
              {pill}
            </span>)}
        </div>

        <CTAButton onClick={scrollToPricing} className="mb-6 md:mb-8 w-full sm:w-auto" data-id="element-152">
          💛 QUIERO CONECTAR CON MI PAREJA AHORA
        </CTAButton>

        <div className="flex flex-wrap justify-center items-center gap-3 sm:gap-6 text-xs md:text-sm font-sans text-brown/60" data-id="element-153">
          <div className="flex items-center gap-1.5" data-id="element-154">
            <ShieldCheck size={16} data-id="element-155" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-1.5" data-id="element-156">
            <CreditCard size={16} data-id="element-157" /> Pago seguro Mercado Pago
          </div>
          <div className="flex items-center gap-1.5" data-id="element-158">
            <Users size={16} data-id="element-159" /> +500 Parejas
          </div>
          <div className="flex items-center gap-1.5" data-id="element-160">
            <Star size={16} className="text-terracotta fill-terracotta" data-id="element-161" /> 4.9
            Rating
          </div>
          <div className="flex items-center gap-1.5" data-id="element-162">
            <MapPin size={16} data-id="element-163" /> Todo Argentina
          </div>
        </div>
      </motion.div>
    </section>;
}